import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { routerInstance } from "./routes";
import AuthContextProvider from "./core/contexts/AuthContext";
import AppContextProvider from "./core/contexts/AppContext";
import reportWebVitals from "./reportWebVitals";
import "./core/styles/index.scss";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
    //<React.StrictMode>
    <AuthContextProvider>
        <AppContextProvider>
            <RouterProvider router={routerInstance} />
        </AppContextProvider>
    </AuthContextProvider>
    //</React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
